document.addEventListener("DOMContentLoaded", function () {
	const jobInput = document.getElementById("id_job-custom_job_number");
	const jobIDSpan = document.getElementById("jobID");

	if (!jobInput || !jobIDSpan) {
		return;
	}

	function updateJobID() {
		jobIDSpan.textContent = jobInput.value.trim() || jobInput.placeholder;
	}

	// Initial update in case input is pre-filled
	updateJobID();

	jobInput.addEventListener("input", updateJobID);
	jobInput.addEventListener("change", updateJobID);
});